export const PERIOD_START = new Date(2017, 0, 1);
export const PERIOD_END = new Date(2021, 5, 1);
export const INCOME = 2000;
export const CONTRIBUTION = 0.15;
export const RISK = 2;
export const DATE_FORMAT = 'YYYY-MM-DD';
